import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { UserInvite } from '@app/shared/models/user-invite';
import { OwnerUsers } from '@app/shared/models/user';

@Injectable({
  providedIn: 'root',
})
export class WorkspacesService extends ApiService {
  constructor() {
    super();
    this.url = 'workspaces/';
  }

  sendInviteToUsers(usersToInvite: UserInvite[]): Observable<unknown> {
    return this.post({ url: 'invite', body: usersToInvite });
  }

  reinviteUser(userId: number): Observable<unknown> {
    return this.post({
      url: `reinvite?userId=${userId}`,
    });
  }

  removeFromWorkspace(userId: number): Observable<unknown> {
    return this.delete({
      url: `removeFromWorkspace?userId=${userId}`,
    });
  }

  getUsers(): Observable<OwnerUsers> {
    return this.get({ url: `` });
  }
}
